import { IQuoteAttachment } from "@cai-services";
import { Quote } from "./quote.model";

export class QuoteAttachment implements IQuoteAttachment {
  id: number;
  fileName: string;
  fileType: string;
  fileSize: number;
  uploadSuccessful: boolean;
  quote: Quote;

  constructor (
    fileName: string,
    fileType: string,
    fileSize: number,
    id?: number,
    quote?: Quote
  ) {
    this.fileName = fileName;
    this.fileType = fileType;
    this.fileSize = fileSize;
    this.id = id;
    this.quote = quote;
  }
}
